import NodeStatus from 'features/Integrations/components/NodeStatus/NodeStatus';
import { Accordion as BaseAccordion } from 'react-bootstrap';
import { FaCog } from 'react-icons/fa';

export default function GroupDevicesAccordion({
  groupDevices,
  selectedDeviceId,
  onSelectDevice,
  onDeviceSettingsOpen,
  canEditDevice,
}) {
  return (
    <BaseAccordion className="bordered-table-accordion">
      {groupDevices.map((device, index) => (
        <BaseAccordion.Item
          key={device.id ?? index}
          eventKey={String(index)}
          className="bordered-table-accordion-item"
        >
          <BaseAccordion.Header>
            <div
              className="d-flex w-100 justify-content-between align-items-center gap-2 pe-2"
              onClick={() => onSelectDevice(device.id === selectedDeviceId ? null : device.id)}
            >
              <div className="d-flex flex-column">
                <span className="fw-semibold text-break">{device.alias}</span>
                <span className="text-secondary text-break">{device.name}</span>
              </div>
              <NodeStatus device={device} />
            </div>
          </BaseAccordion.Header>
          <BaseAccordion.Body className="bg-primary-shadow">
            <div className="d-flex align-items-center justify-content-between gap-2">
              <div>
                <span className="fw-semibold">ID:</span> {device.node_id}
              </div>
              {canEditDevice(device) && (
                <button
                  type="button"
                  className="btn btn-link p-0 text-white"
                  onClick={(event) => onDeviceSettingsOpen(event, device)}
                >
                  <FaCog size={24} />
                </button>
              )}
            </div>
          </BaseAccordion.Body>
        </BaseAccordion.Item>
      ))}
    </BaseAccordion>
  );
}
